export default __webpack_public_path__ + "static/media/financialsituation1Img5.9c045a7e.png";